import TransactionLimit from '../../components/controls/TransactionLimit/TransactionLimit';
import { UserTransactionLimit } from '../../models/interfaces';
import classes from './user-transaction-limit-form.module.css';
import { useNavigate, useSearchParams } from 'react-router-dom';
import userService from '../../services/userService';

export interface UserTransactionLimitFormProps { }

function UserTransactionLimitForm(props: UserTransactionLimitFormProps) {
	const [queryParams] = useSearchParams();
	const navigate = useNavigate();

	const userQueryId = Number(queryParams.get("id"));
	if (userQueryId === 0) {
		navigate('../../');
	}

	return (
		<div className='row'>
			<div className="col">
				<h3>Configure User Transaction Limit</h3>

				<TransactionLimit<UserTransactionLimit>
					onGetTransactionLimits={async () => {
						return userService.getTransactionLimits(userQueryId);
					}}
					onSaveChanges={async (limit) => {
						const resp = await userService.setUserTransactionLimit(limit, userQueryId);
						if (resp.status) {
							return new Promise<UserTransactionLimit>((resolve, reject) => {
								resolve(resp.data as UserTransactionLimit);
								reject('Unable to get the user transaction limit');
							});
						}
					}}
					onDeleteLimit={async (limit, limits) => {
						const resp = await userService.deleteUserTransactionLimit(limit, userQueryId);
						if (resp.status && resp.data) {
							const newLimits = limits.filter(d => !(d.userId === limit.userId && d.period === limit.period && d.transactionType === limit.transactionType));
							return newLimits;
						}
					}}
				/>

			</div>
		</div>
	);
}

export default UserTransactionLimitForm;